<template>
    <div id="downloadReceipt">
        <div style="margin-top: 30px;">
            <section>
                <div style="text-align: center; margin-bottom: 20px;">
                    <img style="max-width: 200px;max-height: 200px;" src="../../../assets/img/zhulia-07.png"/>
                </div>
            </section>
            <section class="d-flex justify-content-between">
                <div style="font-size: 30px;font-weight:bolder;verti">Receipt</div>
                <div>
                    <div class="form-group row">
                        <label for="date" style="padding-top:10px;padding-right:10px;font-size: 15px;">Invoice Date</label>
                        <div style="padding-top: 10px;line-height: 21px;border-bottom: 2px solid #000;">
                            {{ data.invoiceDate }}
                        </div>
                    </div>
                </div>
                <div>
                    <div class="form-group row">
                        <label for="date" style="padding-top:10px;padding-right:10px;font-size: 15px">Invoice No</label>
                        <div style="padding-top: 10px;line-height: 21px;border-bottom: 2px solid #000;width:100px;">
                            {{ data.invoiceNumber }}                        
                        </div>
                    </div>
                </div>
            </section>
            <section class="d-flex justify-content-between w-100">
                <div class="form-group row ml-0">
                    <label for="date" style="padding-top:10px;padding-right:20px;font-size: 15px">Received From</label>
                    <div style="padding-top: 10px;line-height: 21px;border-bottom: 2px solid #000;width:350px;">
                    {{ data.receivedBy }}
                    </div>
                </div>
                <div class="form-group row">
                    <label for="date" style="padding-top:10px;padding-right:30px;font-size: 15px">Amount</label>
                    <div style="padding-top: 10px;line-height: 21px;border-bottom: 2px solid #000;width:120px;">
                    {{ data.amount }}
                    </div>
                </div>
            </section>
            <section >
                <div>
                    <div class="d-flex justify-content-start w-100">
                        <label for="date" style="padding-top:10px;padding-right:10px;font-size: 15px">Amount in words(Ksh)</label>
                        <div style="padding-top: 10px;line-height: 21px;border-bottom: 2px solid #000;width:547px;">
                        {{ displayAmountInWordKsh }}
                        </div>
                    </div>
                </div>
            </section>
            <section >
                <div>
                    <div class="d-flex justify-content-start w-100">
                        <label for="date" style="padding-top:10px;padding-right:10px;font-size: 15px">Amount in words(Ghp)</label>
                        <div style="padding-top: 10px;line-height: 21px;border-bottom: 2px solid #000;width:547px;">
                       {{ displayAmountInWordGhp }}
                        </div>
                    </div>
                </div>
            </section>
            <section >
                <div>
                    <div class="d-flex justify-content-start w-100">
                        <label for="date" style="padding-top:10px;padding-right:10px;font-size: 15px">Payment Method</label>
                        <div style="padding-top: 10px;line-height: 21px;border-bottom: 2px solid #000;width:547px;">
                        {{ data.paymentMethod }}
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div>
                    <div class="d-flex justify-content-start w-100">
                        <label for="date" style="padding-top:10px;padding-right:10px;font-size: 15px">Payment Date</label>
                        <div style="padding-top: 10px;line-height: 21px;border-bottom: 2px solid #000;width:547px;">
                            {{ data.paymentDate }}
                        </div>
                    </div>
                </div>
            </section>
            <section class="mb-5">
                <div>
                    <div class="d-flex justify-content-start w-100">
                        <label for="date" style="padding-top:10px;padding-right:30px;font-size: 15px">Received By</label>
                        <div style="padding-top: 10px;line-height: 21px;border-bottom: 2px solid #000;width:547px;">
                        {{ data.receivedFrom }}
                        </div>
                    </div>
                </div>
            </section>
        </div>  
    </div>
</template>

<script>
import numWords from 'num-words';

    export default {
        name:'DownloadReceipt',
        data(){
            return{
                data: {
                    date: '',
                    invoiceNumber:'',
                    receivedFrom: '',
                    amount: '',
                    amtInKsh:0,
                    amtInGhp: 0,
                    paymentMethod: '',
                    receivedBy: ""
                }
            }
        },
        computed: {
            displayAmountInWordKsh(){
                return numWords(this.data.amtInKsh)
            },
            displayAmountInWordGhp(){
                return numWords(this.data.amtInGhp)
            }
        },
        methods:{
            downloadReceiptData(previewData){
                this.data =  previewData;
                setTimeout(() =>  this.$htmlToPaper('downloadReceipt'), 1000);
            },
        }
    }
</script>

<style scoped>
.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}
#downloadReceipt{
    display: none;
}
.img{
    max-width: 50px;
    max-height: 50px;
}

</style>